import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleCountryEducationalForm extends TitleBase {
	private countryValue: string;
	private educationalFormValue: string;

	protected canHandle(): boolean {
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);
		this.educationalFormValue = this.getFilterValue(ParameterType.EDUCATIONAL_FORM);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			this.indexableFilters.some((_) => _.type === ParameterType.EDUCATIONAL_FORM)
		);
	}

	protected getPageTitle(): string {
		return `${this.educationalFormValue} in ${this.countryValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(
			`${this.educationalFormValue} ${this.titlePortalType}`,
			` in ${this.countryValue}`
		);
	}
}
